import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var PolygonMaskMove = /*#__PURE__*/function () {
  function PolygonMaskMove() {
    _classCallCheck(this, PolygonMaskMove);
    this.radius = 10;
    this.type = "path";
  }
  _createClass(PolygonMaskMove, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.radius !== undefined) {
        this.radius = data.radius;
      }
      if (data.type !== undefined) {
        this.type = data.type;
      }
    }
  }]);
  return PolygonMaskMove;
}();